// extracted by mini-css-extract-plugin
module.exports = {"bannerPreview":"styles_bannerPreview__2_79p","currentBanner":"styles_currentBanner__3FF0Z","previewDark":"styles_previewDark__38HU5","previewLight":"styles_previewLight__EN_QS"};